import React from 'react'
import { Navigate } from 'react-router-dom'

const isAuthenticated = () => {
    return !!localStorage.getItem('token')
}

export default function PrivateRoute({ children }) {
    return isAuthenticated() ? children : <Navigate to="/auth/sign-in" replace />
}